import React, {useEffect, useState} from "react";
import {CustomBackdrop, StyledContainer} from "../utils/customStyles";
import ShowSnackbar from "../utils/ShowSnackbar";
import {styled, Button, Alert} from "@mui/material";
import AssignmentIcon from '@mui/icons-material/Assignment';
import AddIcon from '@mui/icons-material/Add';
import HispsCreateDialog from "./HispsCreateDialog";
import HispsAssignCertDialog from "./HispsAssignCertDialog";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import {ApiUrl} from "../utils/portal-urls";
import HispsAsList from "./HispsAsList";
import RefreshIcon from '@mui/icons-material/Refresh';
import ShowMessage from "../utils/show-message";

const StyledButton = styled(Button)({
    display: 'flex',
    gap: '10px',
    float: 'right',
})
export const initialHisp = {
    hispId: '',
    hispName: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    status: '',
    admin: false,
    comment: '',
}
export const PageAlert = (props) => {
    const pageResult = props.pageResult;
    return (
        pageResult &&
        <Alert severity='info' icon={false}>
            Found {pageResult.totalElements} record(s). &nbsp;
            {pageResult.totalPages > 1 && `Showing page ${pageResult.pageable.pageNumber + 1} (${pageResult.pageable.offset + 1} ... ${pageResult.pageable.offset + pageResult.pageable.pageSize})`}
        </Alert>
    )
}

export default function HispsHome() {
    const getParameters = getQueryParams();

    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(new Date().getTime());
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''});
    const [createHispDialog, setCreateHispDialog] = useState({open: false, hisp: initialHisp});
    const [assignCertDialogOpen, setAssignCertDialogOpen] = useState(false);

    // get Hisps
    const [hispsResult, setHispsResult] = useState(null);
    const [page, setPage] = useState(getParameters.page ? parseInt(getParameters.page) : 0);
    const [query, setQuery] = useState("");
    const [queryCount, setQueryCount] = useState(0);
    const [currentViewingQuery, setCurrentViewingQuery] = useState(null);

    useEffect(() => {
        console.log("page changed or refresh, useEffect fetch: ", query, page);
        if (query !== currentViewingQuery && queryCount > 0 && page > 0) {
            setPage(0);
        } else {
            fetchHispsResult(query, page);
        }
    }, [query, page, refresh])

    const fetchHispsResult = async (query, page) => {
        setLoading(true);
        const url = ApiUrl.Hisps.query.getPath(query, page);
        console.log("GET Hisps from: " + url);
        try {
            const res = await fetch(url);
            const data = await handleHttpResponse(res);
            setCurrentViewingQuery(query);
            setHispsResult(data);
        } catch (err) {
            console.error("Failed to get Hisps", err);
            setSnackbarMsg({open: true, msg: "Failed to get Hisps", msgLv: 'error'});
        } finally {
            setLoading(false);
        }
    }

    const handleCreateHispClick = () => {
        setCreateHispDialog({...createHispDialog, open: true});
    }

    const handleAssignCertClick = () => {
        setAssignCertDialogOpen(true);
    }

    const onRefresh = () => {
        setRefresh(new Date().getTime());
    }

    return (
        <StyledContainer maxWidth='xl'>
            {hispsResult?.content &&
                <div>
                    <HispsCreateDialog setRefresh={(c) => setRefresh(c)} setCreateHispDialog={(c) => setCreateHispDialog(c)}
                                       createHispDialog={createHispDialog} hispResult={hispsResult.content} refresh={refresh}/>
                    <HispsAssignCertDialog setRefresh={(c) => setRefresh(c)} setAssignCertDialogOpen={(c) => setAssignCertDialogOpen(c)}
                                           assignCertDialogOpen={assignCertDialogOpen} hispsResult={hispsResult.content}/>
                </div>
            }
            <h3 className="title">
                Hisps Table
                <StyledButton variant='outlined' startIcon={<RefreshIcon/>} onClick={onRefresh}>
                    Refresh
                </StyledButton>
                <StyledButton variant='contained' startIcon={<AssignmentIcon/>} onClick={handleAssignCertClick}>
                    Assign Certificate
                </StyledButton>
                <StyledButton variant='contained' startIcon={<AddIcon/>} onClick={handleCreateHispClick}>
                    Create Hisp
                </StyledButton>
            </h3>
            {hispsResult?.content?.length ?
                <div>
                    <PageAlert pageResult={hispsResult}/>
                    <div>
                        <HispsAsList hispsResult={hispsResult.content} setRefresh={(c) => setRefresh(c)} refresh={refresh}/>

                    </div>
                </div>
                : <Alert severity='info' icon={false}>No Hisps found</Alert>
            }
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg}/>
            <CustomBackdrop open={loading}/>
        </StyledContainer>
    )
}